import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { close } from '../../lightboxes/menus/menu.js'
import * as lightbox from '../../lightboxes/lightbox.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { src, width, height } = one('img', button)
    const library = closest('[data-contract="menu.library"]', button)
    const origin = lightbox.opener(library)
    const form = closest('form', origin)
    const rte = one('iframe[data-rte]', form)
    const { contentDocument } = rte
    const { body } = contentDocument

    close()

    if (rte) {
      contentDocument.execCommand('InsertImage', false, src)

      const img = one(`[src="${src}"]:not([width])`, body)
      img.width = width
      img.height = height
    }
  }
})

export default button => {
  onClick.listen(button)
}